import React from 'react';

const Blog = () => {
  return (
    <section className="blog page-section">
      <span className="section-label">Blogi</span>
      <h1 className="section-heading">Ajankohtaiset muistiinpanot</h1>
      <p className="section-subtitle">
        Kirjoitan workflowista, jälkikäsittelytekniikoista ja projekteista blogissa. Se päivittyy kuukausittain
        ja sisältää myös behind-the-scenes -materiaalia.
      </p>
      <a className="btn btn-secondary" href="https://blog.takanen.eu/" target="_blank" rel="noreferrer">
        Siirry blogiin
      </a>
    </section>
  );
};

export default Blog;
